export class SelfieProcessHandler {
    async handle(image) {
        throw new Error("handle method must be implemented.");
    }
}